import { render, staticRenderFns } from "./cxbz.vue?vue&type=template&id=25ced70c"
import script from "./cxbz.vue?vue&type=script&lang=js"
export * from "./cxbz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports